import script from "./FacebookFeedView.vue?vue&type=script&setup=true&lang=js"
export * from "./FacebookFeedView.vue?vue&type=script&setup=true&lang=js"

import "./FacebookFeedView.vue?vue&type=style&index=0&id=03f06941&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03f06941"]])

export default __exports__